import { Injectable } from "@angular/core";
import { SendChatMessageWS } from "@app/core/chat/data/network/send-chat-message.ws";
import { GetChatSuggestionsWS } from "@app/core/chat/data/network/get-chat-suggestions.ws";
import { ChatRepo } from "@app/core/chat/domain/chat.repo";
import { ChatStreamEvent } from "@app/core/chat/domain/model/chat-stream-event";
import { Observable } from "rxjs";

@Injectable()
export class ChatDataRepo implements ChatRepo {
  constructor(
    private sendChatMessageWS: SendChatMessageWS,
    private getChatSuggestionsWS: GetChatSuggestionsWS
  ) {}

  streamQuestion(
    question: string,
    token: string,
    conversationId: string | null
  ): Observable<ChatStreamEvent> {
    return this.sendChatMessageWS.execute(question, token, conversationId);
  }

  getSuggestions(token: string): Observable<string[]> {
    return this.getChatSuggestionsWS.execute(token);
  }
}
